class Automagic

    constructor: (opt) ->

        # only run for the specified logged in username
        @username = opt.username

        if $('.admin-header .logged-as').text().indexOf("Logged in as #{@username}") is -1
            return null

        # only run for the specified masquerade user (if specified)
        @masqueradeUser = opt.masqueradeUser ? null

        if @masqueradeUser?
            if $('#primary_header a.dropdown-toggle>span:nth-child(2)').text().indexOf(@masqueradeUser) is -1
                return null

        # miscellaneous options
        # @maxWaitTime = opt.maxWaitTime ? 10000
        # @pollInterval = opt.pollInterval ? 200

        # convert all the steps to AutomagicStep objects
        if opt.steps instanceof Array
            @steps = opt.steps
        else
            console.error 'Error in class Automagic: steps must be an array'

        for step, i in @steps
            if step not instanceof AutomagicStep
                @steps[i] = new AutomagicStep step

        # console.log @

        # normally we don't want to just run right away, but we can
        @autorun = opt.autorun ? false
        if @autorun
            @run()


    run: () ->
        # console.log 'Running automagic script...'
        @_runLoop()


    _runLoop: (i = 0, time = 0, doWait = true) ->
        if not @steps[i]? then return
        # console.log "_runLoop(i=#{i},time=#{time})..."
        step = @steps[i]

        if time >= step.maxWaitTime
            console.error "Error in class Automagic: step #{i} timed out after #{time}ms"
            return

        if doWait and step.wait?
            # console.log 'waiting for #{step.wait}ms...'
            setTimeout () =>
                @_runLoop i, 0, false
            , step.wait
            return

        if not step.when()
            # console.log "polling (#{time}ms)..."
            setTimeout () =>
                @_runLoop(i, time + step.pollInterval)
            , step.pollInterval
            return

        # TODO: add event handling stuffs to run when a specified event is fired

        if step.waitAnother?
            setTimeout () =>
                step.do()
                @_runLoop(i + 1)
            , step.waitAnother
        else
            step.do()
            @_runLoop(i + 1)
